import React from 'react';
import {Button, Icon as SemanticIcon} from 'semantic-ui-react';
import classNames from 'classnames';

import './index.scss';

import {Props} from './types';

const Icon = (props: Props) => {
  return (
    <div className={classNames('a__icon', {yellow: props.color === 'yellow'})}>
      <Button icon onClick={props.onClick}>
        <SemanticIcon name={props.name} />
      </Button>
    </div>
  );
};

export default Icon;
